export function FormatNumericInput(num) {
  return num.replace(/\./g, ",");
}
